import { Box } from '@mui/material'
// eslint-disable-next-line import/no-extraneous-dependencies
import * as echarts from 'echarts'
import { useEffect, useMemo, useRef } from 'react'
import { getCurrency } from '../../../lib/currency'
import { averta } from '../../../asset/font'

const BarChart = ({ data = { names: [], date: [] }, className = '', isPC = false }) => {
  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)
  const options = useMemo(() => {
    const { names = [], date = [] } = data
    return {
      grid: {
        top: 10,
        left: isPC ? 60 : 54,
        // 代替width: '100%'，自适应填满容器
        right: 0
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontFamily: averta.style.fontFamily
        },
        extraCssText: 'border-radius: 12px;z-index: 5;'
      },
      legend: {
        data: names || [],
        left: isPC ? 'center' : 'left',
        bottom: isPC ? 12 : 16,
        itemWidth: isPC ? 14 : 12,
        itemHeight: isPC ? 14 : 12,
        itemGap: 24,
        icon: 'circle',
        textStyle: {
          fontFamily: averta.style.fontFamily
        }
      },
      xAxis: [
        {
          type: 'category',
          data: date || [],
          axisPointer: {
            type: 'shadow'
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: isPC ? 16 : 14,
            color: '#75798D',
            // 坐标轴刻度标签的显示间隔,设置成 0 强制显示所有标签
            interval: 0,
            fontFamily: averta.style.fontFamily
          },
          axisLine: {
            // 坐标轴线线宽: 无效
            width: 2,
            // 坐标轴线样式
            lineStyle: {
              color: '#E0E2EF'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          interval: 500,
          min: 500,
          axisLabel: {
            // eslint-disable-next-line no-template-curly-in-string
            formatter: '${value}',
            fontSize: isPC ? 16 : 14,
            color: '#75798D',
            fontFamily: averta.style.fontFamily
          }
        }
      ],
      series: [
        {
          name: names?.[0] || '',
          type: 'bar',
          barWidth: isPC ? 28 : 20,
          // 不同系列的柱间距离
          barGap: 0,
          color: '#19B683',
          tooltip: {
            valueFormatter(value) {
              return (value ?? false) && value > 0 ? `$${getCurrency(value, 0) || '--'}` : '/'
            }
          },
          data: data?.[names?.[0]] || []
        },
        {
          name: names?.[1] || '',
          type: 'bar',
          barWidth: isPC ? 28 : 20,
          barGap: 0,
          color: '#2A61FF',
          tooltip: {
            valueFormatter(value) {
              return (value ?? false) && value > 0 ? `$${getCurrency(value, 0) || '--'}` : '/'
            }
          },
          data: data?.[names?.[1]] || []
        }
      ]
    }
  }, [data, isPC])

  useEffect(() => {
    if (!chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current)
    }
    const resizeHandler = () => {
      chartInstanceRef.current.resize()
    }

    window.addEventListener('resize', resizeHandler)

    return () => {
      window.removeEventListener('resize', resizeHandler)
      chartInstanceRef.current.dispose()
    }
  }, [])
  useEffect(() => {
    chartInstanceRef.current?.setOption?.(options)
  }, [options])
  return <Box ref={chartRef} className={`h-full ${className}`} />
}

export default BarChart
